var _rect, _rect2, _circle, _ellipse, _path, _path2, _circle2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenInterestLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599609,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_11114_52212)",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09961,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "#0D1A16",
    strokeOpacity: 0.07
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.8271,
    cy: 26.6591,
    r: 3.40909,
    fill: "#02B27F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.372,
    cy: 26.6591,
    rx: 3.40909,
    ry: 3.40909,
    fill: "#02B27F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6001 40.9773V36.2046C45.6001 33.5687 43.4633 31.4319 40.8274 31.4319V31.4319C38.1915 31.4319 36.0547 33.5687 36.0547 36.2046V40.9773",
    stroke: "#02B27F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1451 40.9773V36.2046C25.1451 33.5687 23.0082 31.4319 20.3723 31.4319V31.4319C17.7364 31.4319 15.5996 33.5687 15.5996 36.2046V40.9773",
    stroke: "#02B27F",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5992,
    cy: 23.0553,
    r: 3.8961,
    fill: "#F2AE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0536 42.341V34.1591C36.0536 31.1467 33.6115 28.7046 30.5991 28.7046V28.7046C27.5866 28.7046 25.1445 31.1467 25.1445 34.1591V42.341",
    stroke: "#F2AE00",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11114_52212",
    x1: 9.59961,
    y1: 2,
    x2: 60.5996,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInterestLight);
export default __webpack_public_path__ + "static/media/openInterestLight.457973b2e04a2991136e6b034fd763e4.svg";
export { ForwardRef as ReactComponent };